import styles from "./separator.module.css";

export const Separator = () => {
    return (
        <div className={styles.separator} />
    );
}